import React from "react";
import { Link } from "react-router-dom";
// import {
//     Cart
// } from "../../assets/icons/icons";
export default function Header() {
    return (
        <header className="relative py-[15px] shadow-[0px_0px_10px_rgba(0,0,0,0.07)] bg-white">
            <div className="px-[50px] flex items-center justify-between">
                <Link to={"/"}>
                    <img className="w-[90px] h-full" src={require("../../assets/logo/logo.svg").default} alt=""/>
                </Link>
                <div className="relative w-[550px]">
                    <img className="w-[15px] h-[15px] absolute z-10 top-[30%] left-[2%]" src={require("../../assets/icons/search.svg").default} alt="" />
                    <input className="w-full relative py-[8px] px-[40px] outline-none shadow-[0_0_10px_rgba(0,0,0,0.10)] rounded-[4px] relative" type="search" placeholder="Search" />
                </div>
                {/* <div className="flex items-center gap-[7px]">
                    <div>
                       <Cart/>
                    </div>
                    <div>
                        <img className="w-[20px] h-[20px]" src={require("../../assets/icons/lang.svg").default} alt="" />
                    </div>
                </div> */}
            </div>
        </header>
    );
}